<div [formGroup]="form">
  <!--<mat-form-field appearance="outline">-->
  <mat-select disableOptionCentering (openedChange)="openedChange($event)" (selectionChange)="onFilterChange($event)" [formControlName]="field.controlName" [placeholder]="placeholderText" [multiple]="field.multipleSelect"
              #matSel [matTooltip]="getToolTipData(matSel)">
    <!--kendoTooltip [title]="matSel.triggerValue"-->
    <mat-select-search [formControl]="dropdownSearchTextboxControl"></mat-select-search>

    <div class="d-flex" style="align-items: center; justify-content: center; margin: 10px 4px;" *ngIf="filteredDataSource.length > 0 && field.multipleSelect">
      <button class="primaryBtnOutline w-100" (click)="selectAll(true)" medpt-log-action="Click" medpt-log-message="Select all data from dropdown" style="height: 32px; font-size: 12px; margin-right: 5px;">Select All</button>
      <button class="primaryBtnOutline w-100" (click)="selectAll(false)" medpt-log-action="Click" medpt-log-message="Deselect all data from dropdown"  style="height: 32px; font-size: 12px; margin-left: 5px; ">Deselect All</button>
    </div>

    <div class="mat-option-container">
      <mat-option [value]="option.Value" *ngFor="let option of filteredDataSource">
        <span [innerHTML]="option.Text" [title]="option.Text" kendoTooltip></span>
      </mat-option>
    </div>
  </mat-select>  
  <!--</mat-form-field>-->
</div>
